/* eslint-disable import/no-anonymous-default-export */
import { API_CONFIG } from '../config/api.config';
import { IApiResponse } from '../domain/interfaces/Subscription';
import HttpService from './http.service';

// Interfaces para las solicitudes de servicio
export interface ServiceRequest {
  leadPrice: any;
  serviceTitle: string;
  id: string;
  serviceName: string;
  userName: string;
  userEmail: string;
  serviceDate: string;
  cityName: string;
  status: string;
}

export interface CompanyDashboardData {
  totalLeads: number;
  totalPaid: number;
  totalServices: number;
  serviceRequests: ServiceRequest[];
}

class CompanyService {
  async addLead(companyId: string): Promise<any> {
    try {
      const token = localStorage.getItem('auth_token');

      const response = await fetch(`${API_CONFIG.BASE_URL}api/companies/${companyId}/leads`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token ? `Bearer ${token}` : ''
        }
      });

      if (!response.ok) {
        throw new Error(`Error al añadir lead: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      throw error;
    }
  }

  async getServiceRequests(companyId: string): Promise<ServiceRequest[]> {
    try {
      const url = `${API_CONFIG.BASE_URL}api/service-requests/company/${companyId}`;
      const token = localStorage.getItem('auth_token');
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token ? `Bearer ${token}` : ''
        }
      });
      const responseData = await response.json();

      return responseData;
    } catch (error) {
      throw error;
    }
  }

  async deleteServiceRequest(requestId: string): Promise<any> {
    try {
      const token = localStorage.getItem('auth_token');
      const response = await fetch(`${API_CONFIG.BASE_URL}api/service-requests/${requestId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token ? `Bearer ${token}` : ''
        }
      });

      if (!response.ok) {
        throw new Error(`Error al eliminar solicitud de servicio: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      throw error;
    }
  }

  async updateLeadPrice(userId: string, leadPrice: number): Promise<any> {
    try {
      const token = localStorage.getItem('auth_token');
      const response = await fetch(`${API_CONFIG.BASE_URL}api/users/${userId}/lead-price`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token ? `Bearer ${token}` : ''
        },
        body: JSON.stringify({ leadPrice })
      });

      if (!response.ok) {
        throw new Error(`Error al actualizar precio de leads: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      throw error;
    }
  }

  changeCompanyState(id: string, newState: string): Promise<IApiResponse<any>> {
    try {
      const response = HttpService.patch<IApiResponse<any>>(`/api/companies/${id}/state`, { newState });
      return response;
    } catch (error) {
      throw error;
    }
  }

}

//export default new CompanyService();
const companyService = new CompanyService();
export default companyService;
